<template>
  <div class="pjmain">
    <div class="content" v-cloak>
      <van-tabs v-model="active" color="#00d2ff">
        <van-tab title="详情信息">
          <div class="pjxqtitle" v-if="type == 1">
            <!-- <div>
          <button class="dpj">{{ tsxq.status }}</button>
        </div> -->
            <div class="sm-tit">投诉信息</div>
            <p><span>投诉类型：</span>{{ tsxq.complaintType }}</p>
            <p>
              <span>投诉地址：</span>
              {{ tsxq.address }}
            </p>
            <p><span>投诉人：</span>{{ tsxq.name }}</p>
            <p><span>投诉人电话：</span>{{ tsxq.mobile }}</p>
            <p><span>投诉内容：</span>{{ tsxq.content }}</p>
          </div>

          <div class="sm-tit" v-if="type == 1&&tsxq.attachs.length>0">
            <!-- <p>{{ tsxq.content }}</p> -->
            <p>投诉附件</p>
            <van-image
              v-for="(item, index) in tsxq.attachs"
              width="100"
              height="100"
              fit="contain"
              :src="imgIp + item"
              @click="preview(tsxq.attachs)"
            />
          </div>
          <div class="sm-tit" v-if="type == 1&&tsxq.attachs.length==0">
            <!-- <p>{{ tsxq.content }}</p> -->
            <p>投诉附件</p>
            <span>暂无..</span>
          </div>


          <div class="pjxqtitle" v-if="type == 1&&tsxq.complaintResult">
            <div class="sm-tit">处理结果</div>
            <p><span>结果内容：</span>{{ tsxq.complaintResult.result||'暂无' }}</p>
            <p>
              <span>处理时间：</span>
              {{ tsxq.complaintResult.lastModifiedDate||'暂无' }}
            </p>

          </div>

          <!-- <div class="pjxqtitle" v-if="type == 1&&tsxq.complaintResult.attachs.length>0">
            <div class="sm-tit">处理附件</div>
            <van-image
              v-for="(item, index) in tsxq.complaintResult.attachs"
              width="100"
              height="100"
              fit="contain"
              :src="imgIp + item.webUrl"
              @click="preview1(tsxq.complaintResult.attachs)"
            />


          </div>
 -->



      <div class="pjxqtitle" v-if="type == 2">
        <div>
          {{ bxxq.repairType }} <button class="dpj">{{ bxxq.status }}</button>
        </div>
        <p>紧急程度：{{ bxxq.repairLevel }}</p>
        <p></p>
        <p>{{ bxxq.address }}</p>
        <p>期望上门时间：{{ bxxq.planCompTime }}</p>
        <p>预约上门时间：{{ bxxq.yyRepairTime }}</p>
      </div>
      <div class="bxqk mt10" v-if="type == 1">
        <p>{{ bxxq.content }}</p>
        <van-image
          v-for="(item, index) in bxxq.attachs"
          width="100"
          height="100"
          fit="contain"
          :src="imgIp + item"
          @click="preview(bxxq.attachs)"
        />
      </div>



      

        </van-tab>
        <van-tab title="办理跟踪">
          <van-steps direction="vertical" :active="0">
            <van-step v-for="(item,index) in lcList" :key='index'>
              <h3>{{item.currentActivitiName}}</h3>
              <p>{{item.operateName}} 于{{item.lastModifiedDate}}{{item.action}}</p>
            </van-step>
          </van-steps>
        </van-tab>
      </van-tabs>


    </div>
  </div>
</template>
<script>
import Vue from "vue";
import { Image as VanImage, ImagePreview, Tab,Tabs,Step,Steps } from "vant";

Vue.use(VanImage);
Vue.use(ImagePreview);
Vue.use(Step);
Vue.use(Steps);
export default {
  data() {
    return {
      isPingjia: false,
      zfyy: "",
      active: 0,
      lcList:[],
      showfl: false,
      levels: [
        { id: "0", value: "", text: "满意", title: "" },
        { id: "1", value: "", text: "不满意", title: "" },
      ],
      xzlist: {
        bmid: "",
        typetext: "",
        phone: "",
        bz: "",
      },
      tsxq: {
        attachs:[],
        complaintResult:{
          attachs:[]
         }
        },
      bxxq: {},
      type: 1,
    };
  },
  mounted() {
    var id = this.$route.query.id;
    var type = this.$route.query.type || 1;
    this.type = type;
    this.isPingjia = this.$route.query.pj;
    this.isPingjia = this.$route.query.zhcx;

    this.getLiuch()
    if (type == 1) {
      this.$axios.get("/api/v1/complaint/" + id).then((res) => {
        this.tsxq = res;
      });
    } else {
      this.$axios.get("/api/v1/repair/" + id).then((res) => {
        this.bxxq = res;
      });
    }
  },
  methods: {
    getLiuch() {
      var id = this.$route.query.id;
      this.$axios.get("/api/v1/complaint/process/" + id).then((res) => {
      // console.log("🚀 ~ file: gddetail.vue:199 ~ this.$axios.get ~ res:", res)
      this.lcList=res

      });
    },
    onConfirmfl(value) {
      this.xzlist.bmid = value.value;
      this.xzlist.typetext = value.text;
      this.xzlist.phone = value.phone;
      this.showfl = false;
    },
    changeType(e) {
      console.log(e);
    },
    preview(imgarr) {
      var arr = imgarr.map((obj) => {
        return this.imgIp + obj;
      });
      ImagePreview({
        images: arr,
        onClose() {},
      });
    },
    preview1(imgarr) {
      var arr = imgarr.map((obj) => {
        return this.imgIp + obj.webUrl;
      });
      ImagePreview({
        images: arr,
        onClose() {},
      });
    },
    add() {
      var pass = true;
      for (var key in this.xzlist) {
        if (!this.xzlist[key]) {
          pass = false;
          break;
        }
      }
      if (!pass) {
        this.$dialog({ message: "您还有信息未填" });
        return;
      }
      let data = new FormData();
      var jsonData = {};

      var postUrl = "";
      if (this.$route.query.type == 1) {
        (postUrl = "/api/v1/complaint/handler/rwpd"),
          (jsonData = {
            toUserId: this.xzlist.bmid,
            phone:this.xzlist.phone,
            complaint:{
              id:this.$route.query.id
            },
            content:this.xzlist.bz,
            attachs: []
          });
      } else {
        (postUrl = "/api/v1/repair/saveAssess"),
          (jsonData = {
            myd: this.xzlist.level,
            assessResult: this.xzlist.content,
            repairId: this.$route.query.id,
          });
      }
      // for (let key in jsonData) {
      //   data.append(key, jsonData[key]);
      // }
      this.$axios.post(postUrl, jsonData).then((res) => {
        console.log(res);
        this.$dialog({ message: "提交成功" }).then(() => {
          this.$router.go(-1);
        });
      });
    },
    down() {
      if (this.zfyy == "") {
        this.$dialog({ message: "请写明作废原因" });
        return;
      }
      var data = {
            complaint:{
              id:this.$route.query.id
            },
            content:this.zfyy
          };
      this.$axios.post("/api/v1/complaint/handler/rwzf", data).then((res) => {
        console.log(res);
        this.$dialog({ message: "提交成功" }).then(() => {
          this.$router.go(-1);
        });
      });
    },
  },
};
</script>
<style lang="less" scoped>
[v-cloak] {
  display: none;
}
.bt {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}
.md20 {
  margin-bottom: 20px;
}
.pjmain {
  height: calc(100% - 46px);
  width: 100%;
  background-color: #fff;
}
.shangchuan {
  line-height: 30px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: relative;
  display: -webkit-box;
  display: -webkit-flex;
  display: flex;
  box-sizing: border-box;
  width: 100%;
  padding: 10px 0px;
  overflow: hidden;
  color: #323233;
  font-size: 14px;
  line-height: 24px;
  border-bottom: #f4f4f4 1px solid;
  font-size: 16px;
}
.pj-dv {
  // border-top: 1px solid #f4f4f4;
  margin-top: 20px;
}
.mt10 {
  margin-top: 10px;
}
.sm-tit {
  color: #28aff6;
  span{
    color: #000;
    font-size: 14px;
  }
}
.btn {
  margin-top: 30px;
  outline: none;
  border: none;
  border-radius: 10px;
  color: white !important;
  font-weight: 600;
  background: #28aff6;
  height: 40px;
  width: 70%;
  cursor: pointer;
}
.content {
  height: 100%;
  width: 92%;
  margin: 0 4% 0 4%;
  .pjxqtitle {
    padding: 10px 0;
    font-size: 18px;
    border-bottom: #f4f4f4 1px solid;
    p {
      span {
        display: inline-block;
        color: #999999;
        width: 90px;
        text-align: left;
      }
      font-size: 14px;
      color: #000;
      margin: 0;
      line-height: 2rem;
    }
  }
  .bxqk {
    width: 100%;
    line-height: 25px;
    textarea {
      height: 125px;
      outline: none;
      border: #dddddd 1px solid;
      border-radius: 20px;
      margin-top: 10px;
      margin-bottom: 10px;
      text-indent: 2rem;
      color: #999999;
    }
    p {
      margin: 0;
      padding: 0;
    }
  }
}
.daxing {
  display: flex;
  align-items: center;
  span {
    margin-right: 10px;
  }
}
.tijiao {
  margin-top: 30px;
  margin-bottom: 30px;
  outline: none;
  border: none;
  border-radius: 10px;
  color: white;
  font-weight: 600;
  background: #28aff6;
  height: 40px;
  margin-left: 15%;
  width: 70%;
  cursor: pointer;
}
.dpj {
  height: 25px;
  top: calc(50% - 15px);
  border: 1px solid #00d2ff;
  color: #00d2ff;
  background-color: transparent;
  border-radius: 30px;
  font-size: 15px;
}
</style>